(() => {
  const BUY_BOX_SELECTORS = [
    '#buy-box',
    '[data-buy-box-target]'
  ];

  const getHeaderOffset = () => {
    const cssOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    return cssOffset + 16;
  };

  const scrollToTarget = (target) => {
    if (!target) return;

    const rect = target.getBoundingClientRect();
    const targetTop = rect.top + window.pageYOffset - getHeaderOffset();

    window.scrollTo({
      top: Math.max(targetTop, 0),
      behavior: 'smooth'
    });

    target.classList.add('is-focused');
    target.focus({ preventScroll: true });

    const submitButton = target.querySelector('[id^="ProductSubmitButton-"]');
    if (submitButton) {
      setTimeout(() => submitButton.focus({ preventScroll: true }), 450);
    }

    window.clearTimeout(target._buyBoxHighlightTimer);
    target._buyBoxHighlightTimer = window.setTimeout(() => {
      target.classList.remove('is-focused');
    }, 2200);
  };

  const findBuyBoxTarget = (trigger) => {
    const section = trigger.closest('[id^="MainProduct-"], #ProductConversionStory-main');
    const localTarget = section?.querySelector('[data-buy-box-target]');
    if (localTarget) return localTarget;

    for (const selector of BUY_BOX_SELECTORS) {
      const match = document.querySelector(selector);
      if (match) return match;
    }

    return null;
  };

  const shouldHandleDescriptionTrigger = (trigger) => {
    if (!trigger.closest('.product__description')) return false;
    const href = trigger.getAttribute('href');

    return (
      trigger.hasAttribute('data-buy-box-scroll') ||
      href === null ||
      href === '' ||
      href === '#' ||
      href === '#buy-box' ||
      href === '#product-form' ||
      href === 'javascript:void(0)'
    );
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('a, button');
    if (!trigger) return;

    const wantsBuyBoxScroll =
      trigger.hasAttribute('data-buy-box-scroll') ||
      shouldHandleDescriptionTrigger(trigger);

    if (!wantsBuyBoxScroll) return;

    event.preventDefault();
    scrollToTarget(findBuyBoxTarget(trigger));
  });
})();
